import React from 'react'
import { withTranslation } from 'react-i18next'
import Button from 'app/components/ButtonDefault'
import { IMultipleProtrackLevelsProps, IOnboardingLevelProps } from '../interface'
import Divider from 'app/components/Divider/Divider'
import '../styles.scss'
import './styles.scss'

export const bc = 'protrack-level'

const MultipleProTracks: React.FC<IMultipleProtrackLevelsProps> = ({
  proTrackLevels,
  t,
  setQueriesAndGoToDashboard,
}) => {
  return (
    <div>
      {proTrackLevels.map(({ proTrackName, welcomeText, activities, id, image }: IOnboardingLevelProps, i: number) => {
        const activity = activities?.[0]
        return (
          <div className={bc} key={`${bc}_${i}`}>
            <div className={`${bc}__wrapper multiple`}>
              <div className={`${bc}__left`}>
                <img className={`${bc}__image`} src={image} alt="welcome image" />
              </div>

              <div className={`${bc}__right`}>
                <p className={`${bc}__description`}>
                  <span className={`${bc}__protrack-name`}>{proTrackName}: </span>
                  {welcomeText}
                </p>

                {activity && (
                  <div className={`${bc}__activity multiple`}>
                    <p className={`${bc}__activity-name multiple`}>{activity.name}</p>
                    <p
                      className={`${bc}__activity-description multiple`}
                      dangerouslySetInnerHTML={{ __html: activity.description }}
                    />
                    <Button primary className={`${bc}__button multiple`} onClick={() => setQueriesAndGoToDashboard(id)}>
                      {t('I Commit')}
                    </Button>
                  </div>
                )}
              </div>
            </div>
            <Divider />
          </div>
        )
      })}
    </div>
  )
}

export default withTranslation('user')(MultipleProTracks)
